import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const featuredLogos = [
  "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Desktop/FeaturedBy/The_Economic_Times_logo%201%20(1).svg",
  "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Desktop/FeaturedBy/image%20581.svg",
  "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Desktop/FeaturedBy/image%20582.svg",
  "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Desktop/FeaturedBy/techcrunch_logo.svg.svg",
  "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Desktop/FeaturedBy/the_times_of_india_logosvg.svg",
];

const awardCards = [
  {
    type: "image",
    className: "w-[138px] h-[138px]",
    content: (
      <img
        className="w-full h-full object-contain"
        alt="Rectangle"
        src="https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Desktop/Group%2010460.png"
      />
    ),
  },
  {
    type: "angellist",
    className: "w-[138px] h-[138px] opacity-90",
    content: (
        <img
        className="w-full h-full object-contain"
        alt="Rectangle"
        src="https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Desktop/Group%2010462.png"
      />
    ),
  },
  {
    type: "award",
    className: "w-[138px] h-[138.0px]",
    content: (
        <img
          className="w-full h-full object-contain"
          alt="Award certificate"
          src="https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Desktop/Frame%20427322589.png"
        />
    ),
  },
];

export const AwardsSectionDesktop = () => {

  return (
    <section className="mt-[90px] rounded-[24px] pt-[64px]  flex flex-col items-center  w-full bg-[#406AFF]/10 ">
      <div className="w-full flex items-center justify-between px-[100px] w-full ">
        <div className="flex-1 flex flex-col items-start">
          <h1 className="[font-family:'Inter',Helvetica] leading-[130%] bg-[linear-gradient(135deg,white_0%,white_20%,#F7E394_100%)] bg-clip-text text-transparent text-[32px] tracking-[0] leading-[100%]"  >
            <span className="font-medium mr-1 leading-[130%]">Experience our<br/></span>
            <span className="font-bold leading-[130%] text-[#F7E394]">Award Winning </span>
            <span className="font-medium leading-[130%]">Platform</span>
          </h1>

          <div className="inline-flex items-center">
            <p className="[font-family:'Inter',Helvetica] font-medium text-[#d5edff] text-[24px] tracking-[0] leading-[36px] opacity-80">
              Recognised by
            </p>
            <img
              className="w-[180px] h-auto -ml-3"
              alt="Netflix"
              src="https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Desktop/Netflix.png"
            />
          </div>
        </div>

        <div className=" flex-1 flex justify-between gap-8  items-center px-10">
          {awardCards.map((card, index) => (
            <div key={index} className={card.className}>
              {card.content}
            </div>
          ))}
        </div>
      </div>

      <footer className="mt-[44px] w-full flex items-center gap-10 px-[100px] py-8 w-full  mt-auto rounded-b-[24px]" style={{ background: `linear-gradient(to right, #0D2F5B 0%, #0D396C 51%, #0D305B 100%)`
}}>
        <div className="flex items-center gap-10 w-full max-w-[1440px] mx-auto overflow-hidden">
          <h2 className="[font-family:'Inter',Helvetica] font-bold text-[#00c1ff] text-[24px] tracking-[0] leading-[32px] whitespace-nowrap">
            Featured By
          </h2>

          <div className="flex-1 overflow-hidden">
            <Swiper
              modules={[Autoplay]}
              spaceBetween={64}
              slidesPerView="auto"
              loop={true}
              loopedSlides={featuredLogos.length}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
              }}
              speed={5000}
              allowTouchMove={false}
              className="w-full"
            >
              {[...featuredLogos , ...featuredLogos , ...featuredLogos].map((logo, index) => (
                <SwiperSlide key={index} className="!w-auto">
                  <div className="flex items-center justify-center h-[22px]">
                    <img
                      src={logo}
                      alt={`Featured company ${index + 1}`}
                      className="h-full w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </footer>
    </section>
  );
};
